import { Card as CardAntd, CardProps } from 'antd';
import classNames from 'classnames';
import { memo } from 'react';

export const Card = memo(({ className, ...rest }: CardProps) => {
  return <CardAntd className={classNames('ctv-card', className)} {...rest} />;
});

Card.displayName = 'Card';
